// extracted by mini-css-extract-plugin
export var marker = "styles-module--marker--6010f";
export var row = "styles-module--row--2848f";
export var table = "styles-module--table--e8c0c";
export var title = "styles-module--title--31294";